import React from 'react';
import { GatsbyImage } from "gatsby-plugin-image";

const Installation = (props) => {
  const className = 'installation level' + props.level
  return(
    <div className={className}>
      <GatsbyImage image={props.id.gatsbyImageData} alt="" />
    </div>
  )
}

export default Installation;